// 时间戳转日期
const timeTodate = function(timestamp, format) {
  var formateArr = ['Y', 'm', 'd', 'H', 'i', 's'];
  var returnArr = [];

  if (parseInt(timestamp) === 0) {
    return '-'
  }

  var date = new Date(parseInt(timestamp) * 1000)

  returnArr.push(date.getFullYear());

  var month = date.getMonth() + 1;
  month = month < 10 ? '0' + month : month
  returnArr.push(month);

  var day = date.getDate()
  day = day < 10 ? '0' + day : day
  returnArr.push(day);

  var hours = date.getHours()
  hours = hours < 10 ? '0' + hours : hours
  returnArr.push(hours);

  var minute = date.getMinutes()
  minute = minute < 10 ? '0' + minute : minute
  returnArr.push(minute);

  var second = date.getSeconds()
  second = second < 10 ? '0' + second : second
  returnArr.push(second);

  returnArr.forEach(function(v, i) {
    format = format.replace(formateArr[i], returnArr[i]);
  })
  return format;
}

const moneyFormat = function(num, isdecimal) {
  var y = (num / 100).toString()
  if (isdecimal) {
    var index = y.lastIndexOf('.')
    var zero = '00000'
    if (index == -1) {
      return y + '.00'
    } else {
      return y + zero.substring(0, 3 - y.length + index)
    }
  }

  return y
}

module.exports = {
  timeTodate,
  moneyFormat
}



// WEBPACK FOOTER //
// ./src/utils/filter.js